import React from 'react'

export const MBGBanner = () => {
    return (
        <div className="px-0 mx-4 md:mx-2 xxl:mx-0">
            <div className="flex w-full bg-[#E7EDF3] p-5 md:p-8 mb-4 md:mb-10 rounded-3xl items-center">
                <img className="mr-6" width="69" height="73" src="./mbg.svg" />
                <p className="text-sm md:text-xl">
                    <span className="font-bold text-yf-green">Money Back Guarantee.</span>{' '}
                    Here at Yes.Fit, we stand behind our products. We offer a full Money
                    Back Guarantee if you do not absolutely love your purchase. No
                    hassles, no worries!
                </p>
            </div>
        </div>
    )
}
